import routes from '../../../router.js';
import testSession from './testSession.js';

const loadSession = id =>
  new Promise((resolve, reject) =>
    process.env.NODE_ENV === 'dev'
      ? setTimeout(() => resolve(testSession.data), 500)
      : fetch(`${routes.buy.session}?id=${id}`, {
          headers: {
            Accept: 'application/json',
          },
          method: 'GET',
        })
          .then(response => response.json())
          .then(json =>
            json.status === 'success'
              ? resolve(json.data)
              : reject(new Error(`Ошибка загрузки сеанса: ${json.errors}`)),
          )
          .catch(() => reject(new Error(`Ошибка загрузки сеанса`))),
  );

export default loadSession;
